import { getIdentityBaseUrl } from '@sitecore-ui/portal-singular';
import { env } from 'features/common/config/envConfig';

const baseUrl = getIdentityBaseUrl(env.toLowerCase());

export const groupsApiConfig = {
  create_group: {
    url: `${baseUrl}/organization/groups`,
    scope: 'iam.org_grp:w',
  },
  update_delete_group: {
    url: (groupId: string) => `${baseUrl}/organization/groups/${groupId}`,
    scope: 'iam.org_grp:w',
  },
  get_groups: {
    url: `${baseUrl}/organization/groups`,
    queryKey: ['organization/groups'] as const,
    scope: 'iam.org_grp:r',
  },
  add_delete_group_members: {
    url: (groupId: string) =>
      `${baseUrl}/organization/groups/${groupId}/members`,
    scope: 'iam.org_grp_mbrs:w',
  },
  get_group_members: {
    url: (groupId: string, pagenumber: number) =>
      `${baseUrl}/organization/groups/${groupId}/members?pagenumber=${pagenumber}`,
    scope: 'iam.org_grp_mbrs:r',
    queryKey: ['organization/groups', 'groupId', 'id'] as const,
  },
};
